import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography, Button } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import rem from 'utils/rem'

const MaterialConfirmationForm = ({ onAddAnotherMaterial, onHideModal }) => (
  <form>
    <Stack alignItems="center">
      <Stack direction="row" mt={rem(165)} spacing={rem(16)}>
        <CheckCircleIcon color="primary" sx={{ fontSize: rem(35) }} />
        <Typography variant="h4">New Material Added</Typography>
      </Stack>
      <Typography mt={rem(40)} variant="h5">
        What would you like to do next?
      </Typography>
      <Stack mt={rem(24)} spacing={rem(16)}>
        <Button variant="outlined" onClick={onAddAnotherMaterial}>
          ADD ANOTHER MATERIAL
        </Button>
        <Button variant="contained" onClick={onHideModal}>
          FINISH
        </Button>
      </Stack>
    </Stack>
  </form>
)

MaterialConfirmationForm.propTypes = {
  onHideModal: PropTypes.func,
  onAddAnotherMaterial: PropTypes.func,
}

MaterialConfirmationForm.defaultProps = {
  onHideModal: null,
  onAddAnotherMaterial: null,
}

export default MaterialConfirmationForm
